













import Vue from "vue";
import ShowDocumentQrCodeAction from "@/components/modules/document/toolbar/actions/ShowDocumentQrCodeAction.vue";
import DocumentToolbarMenuButton from "@/components/modules/document/toolbar/DocumentToolbarMenuButton.vue";
import EmailDocumentAction from "@/components/modules/document/toolbar/actions/EmailDocumentAction.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentRoute } from "@/enums";

export default Vue.extend({
    name: "ShareMenuDocumentAction",
    components: { DocumentToolbarMenuButton, EmailDocumentAction, ShowDocumentQrCodeAction },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        isDocumentReady: Boolean,
        documentRoute: String as () => DocumentRoute
    },
    computed: {
        isReviewDocument(): boolean {
            return this.documentRoute === DocumentRoute.ReviewDocument;
        }
    }
});
